import { type Ref, ref, toValue, watchEffect } from 'vue';

import { resolveUrl, type UrlType } from '@/helpers/s3';

export const useSignedUrl = (url: Ref<UrlType> | (() => UrlType)) => {
	const signedUrl = ref<string | null>(null);

	watchEffect(async () => {
		const value = toValue(url);
		signedUrl.value = await resolveUrl(value);
	});

	return signedUrl;
};
